var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBox,"width":"100%","height":"100%"}},[_c('path',{staticClass:"svg-base",attrs:{"d":_vm.path}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }